"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var SeriesResource = /** @class */ (function (_super) {
    tslib_1.__extends(SeriesResource, _super);
    function SeriesResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SeriesResource.endpoint = '/series';
    SeriesResource.MODEL_NAME = 'series';
    return SeriesResource;
}(base_1.default));
exports.default = SeriesResource;
//# sourceMappingURL=series.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/series.js
// module id = FZ0n
// module chunks = 0